import { FC } from 'react';
import Select, { SelectOption } from '../Select/Select';

export interface Props {
    id?: string;
    name?: string;
    onChange: (value: string) => void;
    value: string;
    testId?: string;
    options: SelectOption[];
}

const SlagList: FC<Props> = (props: Props) => {
    if (props?.options?.length < 2) {
        return null;
    }

    return (
        <div className="mb-[24px]">
            <label htmlFor="changeMembership" className="font-normal">
                Velg medlemskap:
            </label>
            <div>
                <Select
                    id={props.id}
                    name={props.name}
                    onChange={(event) => props.onChange(event.target.value)}
                    value={props.value}
                    options={props.options}
                    testId={props.testId}
                />
            </div>
        </div>
    );
};

export default SlagList;
